import { Box } from "@mui/material";
import clsx from "clsx";
import { useCallback, useState } from "react";
import { Button, Text, Modal } from "$components";
import useJStyles from "$hooks/useJStyles";
import { useStyles } from "$containers/Preparation/Parcel.styles";
import { pageConfig } from "$utils/typeConstants/Parcel";
import { ParcelPopinMode, PreparationOrderStatus } from "$types";
import useParcel from "$hooks/useParcel";
import ParcelForm from "$containers/Parcel/ParcelForm";
import ParcelTable from "$containers/Parcel/ParcelTable";

export const Parcel = ({ op, togglePopin }: any) => {
  const { jclasses } = useJStyles();
  const classes = useStyles();
  const [error, setError] = useState<string>("");
  const [isDeleteModalOpen, toggleDeleteModal] = useState<boolean>(false);

  const { parcel, createParcel, updateParcel, deleteParcel } = useParcel(
    op._id,
    null,
    () => toggleDeleteModal(false), // Close delete modal
    togglePopin // Close main popin
  );

  let editMode: ParcelPopinMode =
    op.status === PreparationOrderStatus.PREPARED ||
    op.status === PreparationOrderStatus.IN_PROGRESS
      ? ParcelPopinMode.CREATE
      : ParcelPopinMode.READ;

  if (
    parcel &&
    Object.keys(parcel).length &&
    editMode === ParcelPopinMode.CREATE
  ) {
    editMode = ParcelPopinMode.EDIT;
  }

  const handleSubmit = useCallback(
    async (data) => {
      setError("");
      try {
        if (editMode === ParcelPopinMode.CREATE) {
          createParcel(data);
        } else {
          updateParcel(data);
        }
      } catch {
        setError("Une erreur est survenue");
      }
      togglePopin();
    },
    [togglePopin, editMode, createParcel, updateParcel]
  );

  // if (isFetchingParcel) {
  //   return <Loader />;
  // }

  return (
    <Box className={clsx(jclasses.jWrapper, classes.wrapper)}>
      <Box>
        <Box className={classes.header}>
          <Box>
            <Text type="h2">{pageConfig[editMode].title}</Text>
            <Text type="h3">{`Référence de l'OP : ${op.reference}`}</Text>
          </Box>
          {pageConfig[editMode].displayDeleteButton ? (
            <Button
              color="secondary"
              className={classes.deleteButton}
              onClick={() => toggleDeleteModal(true)}
            >
              Supprimer le colisage
            </Button>
          ) : null}
        </Box>

        {editMode === ParcelPopinMode.READ ? (
          <ParcelTable parcel={parcel} showDetailsTable />
        ) : (
          <ParcelForm parcel={parcel} onSubmit={handleSubmit} />
        )}
      </Box>
      {error && <Box className={classes.errorText}>{error}</Box>}
      <Box className={jclasses.footerForm}>
        <Button color="secondary" onClick={togglePopin}>
          {pageConfig[editMode].cancelButtonText}
        </Button>
        {pageConfig[editMode].displaySubmitButton && (
          <Button type="submit" form="parcelForm">
            Enregistrer
          </Button>
        )}
      </Box>
      <Modal
        textValidate="Supprimer"
        textCancel="Annuler"
        open={isDeleteModalOpen}
        onValidate={deleteParcel}
        onCancel={() => toggleDeleteModal(false)}
      >
        <div className={jclasses.dialogContent} style={{ textAlign: "center" }}>
          <Text>
            Attention
            <br />
            Vous êtes sur le point de supprimer définitivement ce colisage.
            <br />
            Êtes-vous sûr de vouloir continuer ?
          </Text>
        </div>
      </Modal>
    </Box>
  );
};
